module.exports = __webpack_public_path__ + "img/tlb.84a3033d.jpg";